import { Box, Flex, Progress, Text } from "@chakra-ui/react";
import { Col, Row } from "antd";
import { useState } from "react";

import AddRemoveLineButton from "ui/components/Button/AddRemoveLineButton";
import ModalContaBancaria from "ui/components/Features/ContaBancaria/ModalContaBancaria";
import useGetContasBancarias from "core/features/contas_bancarias/hooks/useGetContasBancarias";
import CardDefault from "ui/components/Cards/CardDefault";
import FeedbackPagamentoOnline from "ui/components/FeedbackPagamentoOnline";
import { useLoading } from "ui/components/GlobalLoading";
import ContaItem from "./ContaItem";
import { TenantContaResponse } from "core/features/contas_bancarias/typings";
import { useInvalidateQuery } from "infra/packages/react-query";
import ModalHistoricoContaBancaria from "ui/components/ModalHistoricoTenantConta";

export default function ContasBancarias({ tenant }: { tenant?: string }) {
  const [contaEdit, setContaEdit] = useState<TenantContaResponse | null>(null);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const { doInvalidateQueryWithStringKey } = useInvalidateQuery();
  const [modalHistoricoId, setModalHistoricoId] = useState<string | null>(null);

  const {
    data: contas,
    isLoading,
    isFetching,
    refetch,
  } = useGetContasBancarias({ tenantId: tenant, incluirInativas: true });

  useLoading(isLoading);

  return (
    <CardDefault>
      <Flex mb={8}>
        <Text fontSize="18px" fontWeight="bold">
          Contas bancárias
        </Text>
        <AddRemoveLineButton
          showRemove={false}
          onRemove={() => null}
          onAdd={() => setIsOpenModal(true)}
          containerProps={{ pt: 0, ml: 2, mt: -1 }}
        />
      </Flex>

      {isFetching ? (
        <Progress
          size="sm"
          isIndeterminate
          w="100%"
          my={4}
          colorScheme="cyan"
        />
      ) : null}

      <FeedbackPagamentoOnline tenantId={tenant} />

      {!isLoading && contas?.items.length ? (
        <Box>
          <Row gutter={16}>
            {contas?.items.map((conta, i) => (
              <Box as={Col} mb={4} lg={8} md={12} key={i}>
                <ContaItem
                  onRefresh={() => {
                    refetch();
                  }}
                  onEdit={() => {
                    setContaEdit(conta);
                    setIsOpenModal(true);
                  }}
                  onOpenHistorico={(contaId) => setModalHistoricoId(contaId)}
                  tenant={tenant!}
                  conta={conta}
                />
              </Box>
            ))}
          </Row>
        </Box>
      ) : null}

      {isOpenModal ? (
        <ModalContaBancaria
          defaultValue={contaEdit}
          isOpenModal={isOpenModal}
          onClose={() => {
            setContaEdit(null);
            setIsOpenModal(false);
          }}
          tenantId={tenant}
          onSuccess={() => {
            refetch();
            setContaEdit(null);
            setIsOpenModal(false);
            doInvalidateQueryWithStringKey("/v1/tenants/passos-cadastro");
          }}
        />
      ) : null}

      {modalHistoricoId ? (
        <ModalHistoricoContaBancaria
          tenantContaId={modalHistoricoId}
          isOpenModal={!!modalHistoricoId}
          onClose={() => setModalHistoricoId(null)}
        />
      ) : null}
    </CardDefault>


  );
}
